import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Workflow } from '../../../shared/interfaces/workflow';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { Step } from '../../../shared/interfaces/step';
import { Sale } from '../../../shared/interfaces/sale';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-step-display-terms',
    standalone: true,
    imports: [CommonModule, MatCheckboxModule, ReactiveFormsModule, CheckboxComponent, CKEditorModule],
    templateUrl: './step-display-terms.component.html',
    styleUrl: './step-display-terms.component.scss',
})
export class StepDisplayTermsComponent {

    @Input({ required: true }) public formGroup!: FormGroup;

    @Input({ required: true }) public sale!: Sale;

    @Input({ required: true }) public step!: Step;

    @Input() public workflow: Workflow | undefined;

    public get checkboxText():string {
        return this.step?.settings?.['checkboxText'] as string || '';
    }

    public get content(): string {
        return this.step?.settings?.['content'] as string || '';
    }
}
